<template>
    <transition name="slideDown">
        <div
            v-show="summaryList.length > 0 && !isSummaryHidden"
            ref="summary-booking"
            class="fixed bottom-0 left-0 z-20 summary-booking bg-white w-full px-7 py-5 shadow-lg rounded-t-lg"
        >
            <h5 class="font-normal n-color-text">{{ trans('online_booking.appointments.title') }}</h5>
            <ul class="list-none pl-0 flex flex-col gap-5 mb-0">
                <li
                    class="flex gap-1 items-baseline"
                    v-for="item in summaryList"
                    :key="item.id"
                    @click="setCurrentStep(item.id)"
                >
                    <i class="n-color-text item-icon" :class="item.icon"></i>
                    <span class="truncate">{{ item.status }}</span>
                </li>
            </ul>
        </div>
    </transition>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
    props: {
        isLoginScreen: {
            type: Boolean,
            default: false
        },
    },

    data() {
        return {
            keyboardOpen: false,
        }
    },

    computed: {
        ...mapGetters('OnlineBooking', ['filteredSteps']),
        ...mapState('OnlineBooking', ['currentStep']),

        summaryList () {
            return this.filteredSteps.filter(step => step.complete && step.status);
        },

        isSummaryHidden () {
            const isForbiddenStep = ['confirmation', 'payment'].includes(this.currentStep);
            const isFirstStep = this.filteredSteps[0].id === this.currentStep;
            return isFirstStep || isForbiddenStep || this.keyboardOpen || this.isLoginScreen;
        }
    },

    mounted() {
        // add resize event listener
        window.addEventListener('resize', this.handleResize);
    },

    methods: {
        ...mapActions('OnlineBooking', ['setCurrentStep']),

        handleResize() {
            // this fixes the issue when keyboard is open for the ticket - https://mangoapps.groovehq.com/tickets/123231
            this.keyboardOpen = window.innerHeight < 300;
        }
    },

    watch: {
        summaryList: {
            handler () {
                // get the height of the summary booking
                this.$nextTick(() => {
                    const target = this.$refs['summary-booking'];
                    $('#booking-wrapper').css('margin-bottom', !this.isSummaryHidden ? `${target.offsetHeight - 80}px` : 0);
                });
            },

            deep: true
        }
    },

    beforeUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }
}
</script>

<style scoped>
.summary-booking {
    z-index: 1031;
}

i.item-icon {
    flex: 0 0 2.5rem;
}
</style>
